import { useNavigate } from 'react-router-dom'
import { CopyIcon } from '@radix-ui/react-icons'

import { Button } from '@/components/Button/Button'
import { track } from '@/utils/analytics'

const FUNDING_EMAIL = 'funding@paytrie.com'

type TransactionInstructionsProps = {
  orderId: string
  wallet: string
}

export const InteracBuyInstructions = ({
  orderId,
  wallet,
}: TransactionInstructionsProps) => {
  const navigate = useNavigate()

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(FUNDING_EMAIL).catch(() => {})
    track('etransfer_email_copied', { tx_id: orderId })
  }

  return (
    <div
      data-testid="container-buy-instructions"
      className="flex flex-col gap-5"
    >
      <div
        data-testid="container-buy-steps"
        className="grid grid-cols-2 md:grid-cols-3 mb-3 flex-grow"
      >
        <div
          data-testid="container-buy-heading"
          className="col-span-2 lg:col-span-3"
        >
          <h1 data-testid="text-buy-title" className="uppercase text-2xl">
            Next Steps
          </h1>
          <p data-testid="text-buy-description" className="mb-3">
            Please send your interac e-Transfer using the following instructions
          </p>
        </div>
        <h4 data-testid="text-buy-email-label">Email address</h4>
        <h4 data-testid="text-buy-question-label">Security Questions</h4>
        <h4 data-testid="text-buy-answer-label">Security Answer</h4>
        <div
          data-testid="text-buy-email-value"
          className="flex items-center gap-2"
        >
          <span>{FUNDING_EMAIL}</span>
          <button
            type="button"
            onClick={handleCopyEmail}
            data-testid="btn-buy-copy-email"
            className="text-blue-500 hover:text-blue-700 dark:hover:text-blue-300"
            title="Copy email"
          >
            <CopyIcon />
          </button>
        </div>
        <div data-testid="text-buy-question-value">fayesaytang</div>
        <div data-testid="text-buy-answer-value">862AJ388GR</div>
      </div>
      <div
        data-testid="container-buy-summary"
        className="grid grid-cols-2 md:grid-cols-3 gap-2"
      >
        <div
          data-testid="text-buy-summary-title"
          className="col-span-2 md:col-span-3 uppercase font-normal"
        >
          Order summary
        </div>
        <div data-testid="container-buy-order-id">
          <h4 data-testid="text-buy-order-id-label">Order ID</h4>
          <div data-testid="text-buy-order-id-value">{orderId}</div>
        </div>
        <div data-testid="container-buy-wallet">
          <h4 data-testid="text-buy-wallet-label">Adding to</h4>
          <div data-testid="text-buy-wallet-value">{wallet}</div>
        </div>
        <div data-testid="container-buy-method">
          <h4 data-testid="text-buy-method-label">Receive via</h4>
          <div data-testid="text-buy-method-value">Interac</div>
        </div>
      </div>
      {/* <Button onClick={() => goToPage(Pages.CALC)}>Start over</Button> */}
      <Button
        data-testid="btn-buy-start-over"
        onClick={() => {
          track('start_over_clicked', { from: 'buy', tx_id: orderId })
          navigate('/')
        }}
      >
        Start over
      </Button>
    </div>
  )
}
